import { createRedesignEntry } from "../redesign-page-entry";

export default createRedesignEntry(() => import("./contacts-page"), {
  testId: "rd-contacts-loading",
  shell: { breadcrumbLeaf: { id: "page.footer.contacts", defaultMessage: "Contacts" } },
});
